import styled from 'styled-components'
import { TableDataListType } from '@app.feature/exam/gsat2024-2/modules/detailInfoArticleTableData.module'
import DetailInfoTableBody from './DetailInfoTableBody'
import DetailInfoTableHeader from './DetailInfoTableHeader'

type DetailInfoTableProps = {
  tableDataList: TableDataListType
}

const DetailInfoTable = ({ tableDataList }: DetailInfoTableProps) => {
  return (
    <StyledWrapper>
      <caption>영역별 세부결과 분석</caption>
      <colgroup>
        <col width={158} />
        <col width={158} />
        <col width={158} />
        <col width={58} />
        <col width={58} />
        <col width={58} />
        <col width={58} />
        <col width={58} />
        <col width={58} />
        <col width={58} />
      </colgroup>
      <DetailInfoTableHeader />
      <DetailInfoTableBody tableDataList={tableDataList} />
    </StyledWrapper>
  )
}

export default DetailInfoTable

const StyledWrapper = styled.table`
  table-layout: fixed;
  width: 948px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;

  & > caption {
    width: 0;
    height: 0;
    font-size: 0;
  }
`
